import React, { useCallback } from "react";
import { BreakableText } from "@design-system/BreakableText/BreakableText";
import classNames from "classnames";
import styles from "./SpreadsheetRefChip.module.scss";

export interface RefChipProps {
    icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
    label: string;
    onClick?: () => void;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
}

export const RefChip: React.FC<RefChipProps> = React.memo(function RefChip({
    icon: Icon,
    label,
    onClick,
    onMouseEnter,
    onMouseLeave,
}) {
    const handleKeyDown = useCallback(
        (event: React.KeyboardEvent<HTMLSpanElement>) => {
            if (!onClick || (event.key !== "Enter" && event.key !== " ")) {
                return;
            }
            event.preventDefault();
            onClick();
        },
        [onClick],
    );

    return (
        <div className={styles.chipContainer}>
            <span
                className={classNames(styles.chip, {
                    [styles.clickable]: onClick,
                })}
                role={onClick ? "button" : undefined}
                tabIndex={onClick ? 0 : undefined}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                onClick={onClick}
                onKeyDown={onClick ? handleKeyDown : undefined}
            >
                <Icon className={styles.icon} aria-hidden />
                <BreakableText
                    className={styles.labelRow}
                    text={label}
                    showTooltip
                />
            </span>
        </div>
    );
});
